export const STOREFRONT_TYPE = {
  LMS: 'LMS',
  E_COMMERCE: 'ECOMMERCE',
};
